import { render, staticRenderFns } from "./SupplierPaymentDetail.vue?vue&type=template&id=f15303dc&scoped=true"
import script from "./SupplierPaymentDetail.vue?vue&type=script&lang=js"
export * from "./SupplierPaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplierPaymentDetail.vue?vue&type=style&index=0&id=f15303dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15303dc",
  null
  
)

export default component.exports